var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-xl px-3 py-4 text-white text-center shadow my-5",staticStyle:{"background":"#dc343b"}},[_vm._v(" "+_vm._s(!_vm.hasText ? 'Вы попали на скрытую страницу' : '')+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }